<template>
  <div>
    <StreamBarcodeReader
      v-if="!scan_is_ready"
      @decode="onDecode"
      @loaded="onLoaded"
      @error="onError"
    ></StreamBarcodeReader>

    <v-btn block @click="onSearch">
      <v-icon dark>mdi-magnify</v-icon>
      Поиск УПД по номеру
    </v-btn>

    <v-btn class="readmore-link" color="white" @click="onGoBack">
      <v-icon dark> mdi-arrow-u-left-bottom </v-icon>
      Назад
    </v-btn>

    <v-alert class="top40 console">
      {{ this.scan_result }}
    </v-alert>
  </div>
</template>

<script>
import { StreamBarcodeReader } from "vue-barcode-reader";

export default {
  name: "MrmvUpdScan",
  components: {
    StreamBarcodeReader,
  },
  data: function () {
    return {
      scan_is_ready: false,
      scan_result: null,
    };
  },
  methods: {
    onSendCheck() {
      let send_obj = {
        contract_id: this.upd.contract.id,
        upd_id: this.upd.id,
        amount: this.upd.client_pay,
      };
      this.$store.dispatch("create_new_upd", send_obj).then((data) => {
        alert("Создан ПКО с идентификатором: " + data.id);
        (this.scan_result = null),
          (this.scan_is_ready = false),
          (this.upd = null);
      });
    },
    onDecode(result) {
      if (!this.scan_is_ready) {
       try {
        /*
        Формат QR:
            {
             "docId": 192873978,
             "guid": "eae781ef-44d3-45e3-980a-7b05f265f5b4",
             "extId": "R02H93DHVA39R3",
             "summ": 1863.72
             }
        */
        const result_json = JSON.parse(result);

        if (result_json['docId']) {
         result = result_json['docId'].toString();
        }
       } catch (e) {
        console.log("Некорректный формат QR: " + e.message);
       }

        this.scan_result = "Номер УПД: " + result;
        this.$store.commit("clearUpd");
        this.$store.commit("clearCanceledGoods");
        this.$router.push({ name: "UpdSearch", query: { number: result } });
      }
    },
    onError(result) {
      this.scan_result = result;
    },
    onLoaded() {
      this.scan_result = "Отсканируйте...";
    },
    onSearch() {
      this.$router.push({ name: "UpdSearch" });
    },
    onGoBack() {
      this.$router.push({ name: "Home" });
    },
  },
};
</script>
